const SET_ISSUE_CATEGORIES = (state, payload) => {
  state.issueCategories = payload;
}

export {
  SET_ISSUE_CATEGORIES,
}